export enum InputColor {
  Success = 'success',
  Error = 'error',
  Default = 'default',
}
